import { useTeamContext } from '../context/TeamContext'

/** Whether the current user may create financial transactions (expenses/income). */
export default function useCanWriteFinancials(): boolean {
  const { isTeamMember, teamRole, financialAccess } = useTeamContext()
  return !isTeamMember || teamRole === 'admin' || (teamRole === 'manager' && financialAccess)
}
